// extracted by mini-css-extract-plugin
export var fullWidthButton = "_go-0";